import {GameLobbyState} from '../AppTypes';
import React from 'react';

interface GameToJoinProps {
    lobby: GameLobbyState;
    onJoin: (lobby: GameLobbyState) => void;
}

export class GameToJoin extends React.Component<GameToJoinProps> {
    public render(): JSX.Element {
        return (
            <button type="button" onClick={this.handleClick}>
                Join {this.props.lobby.mapName} ({this.playerCount()})
            </button>
        );
    }

    private handleClick = () => {
        this.props.onJoin(this.props.lobby);
    };

    private playerCount(): string {
        return `${this.props.lobby.players.length}/${this.props.lobby.playerCount}`;
    }
}



// WEBPACK FOOTER //
// ./src/GameToJoin/index.tsx